module.exports = __webpack_public_path__ + "static/media/floral-design-svgrepo-com.c82ff051.svg";